// extracted by mini-css-extract-plugin
module.exports = {"button":"button_button__Y6CqJ","danger":"button_danger__2g-3e","success":"button_success__QhmEK"};